import { Injectable } from '@angular/core'

import { MatSnackBar } from '@angular/material/snack-bar'
import { AuthService } from './auth.service'
@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  constructor(private snackBar: MatSnackBar) {}
  public isLogged: boolean = false
  public enabled: boolean

  public showSnackBar(message: string, duration: number) {
    return this.snackBar.open(message, '', {
      duration: duration,
    })
  }
}
